import { Add } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import ItemForm from "./ItemForm";
import { useState } from "react";
import Item from "./Item";
import Total from "./Total";


export default function Detail({indent, edit, onChange}){

    const [form, setForm] = useState(false)

    const handleRemove = item => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cet article ?");

        if(!ok) return false;

        console.log(item)

        let copy = JSON.parse(JSON.stringify(indent))
        copy.items = copy.items.filter(i => (i.class + i.code) !== (item.class + item.code))

        return onChange(copy)
    }

    const handleAdd = item => {
        let copy = JSON.parse(JSON.stringify(indent))

        let existing = copy.items.find(i => (i.class + i.code) === (item.class + item.code))

        if(!existing) copy.items.push(item);

        setForm(false);

        return onChange(copy)
    }


    return (edit && form) ? 

        <ItemForm
            onSubmit={item => handleAdd(item)}
            onCancel={() => setForm(false)}
        /> 

        :
            
        <Stack>

            {indent.items.map(i => 
                <Item 
                    key={i.class + i.code}
                    data={i}
                    edit={edit}
                    onRemove={() => handleRemove(i)}
                />    
            )}

            {edit &&
                <Button
                    onClick={() => setForm(true)}
                    startIcon={<Add />}
                    size='large'
                >
                    Ajouter un article
                </Button>
            }

            <Total indent={indent} />

        </Stack>

}